module.exports = __webpack_public_path__ + "static/media/paa.13605209.ogg";